<script setup lang="ts">
import LinkComponent from "~/templates/components/cms/LinkComponent.vue";
import PictureElement from "~/templates/elements/PictureElement.vue";
import { DIMENSIONS } from "~/utils/helper/imaging";

export interface ProductCategoryLinkProps {
  image?: object;
  link: {
    label: string;
    link: string;
    type: string;
  };
}

const { image, link } = defineProps<ProductCategoryLinkProps>();

const BREAKPOINTS = {
  start: DIMENSIONS.fixed["200x200"],
};
</script>

<template>
  <div
    class="group/product relative flex items-center gap-3 rounded-2xl bg-light-grey p-4 motion-safe:transition-all motion-safe:duration-300"
  >
    <PictureElement
      v-if="image"
      :img="image"
      :breakpoints="BREAKPOINTS"
      image-rendering="pixelated"
      class="shrink-0"
      img-class="h-16 w-16 object-contain motion-safe:group-hover/product:scale-110 motion-safe:transition-transform duration-300"
    />
    <LinkComponent
      class="stretched-link cursor-pointer font-medium group-hover/product:text-deep-blue"
      :link="link"
    >
      {{ link?.label }}
    </LinkComponent>
  </div>
</template>
